import React from 'react';
import './InterseccionPuzzle.css';

const CLUES = [
  <><em>Lexx</em>, for one (3-2 7)</>,
  <>Liable to <em>snap</em> at any moment (2 4)</>,
  <>Program promising everyone just enough to <em>live</em> on (5 6)</>,
  <>Continuing <em>into</em> the next clause without proper punctuation (3-2)</>,
  <>Long-running NBC <em>soap</em> (4 2 3 5)</>,
  <>One who might say "good on ya'" when you ace a <em>test</em> (6 7)</>,
  <>Camera for photographing <em>some</em> less-than-scenic views (9)</>,
  <>Mission control <em>goal</em> for a hiccup-free return-trip (6 7)</>,
  <><em>Pope</em> overseeing the First Vatican Council (4 2)</>,
  <>Makes up for a previous <em>loss</em> (6 4)</>,
  <>Band of traveling performers <em>that</em> comes from Puerto Rico, perhaps (7 6)</>,
  <>What perpetual quarrelers <em>won't</em> let you have (4 4)</>,
  <><em>Garb</em>-free getaway (6 6)</>,
  <><em>Like</em> an earthquake (7)</>
];

function InterseccionPuzzle() {
  return (
    <div className="interseccion-puzzle">
      <div className="clue-list">
        {CLUES.map((clue, idx) => (
          <div key={idx} className="clue-item">
            {clue}
          </div>
        ))}
      </div>
    </div>
  );
}

export default InterseccionPuzzle;
